export const mapCustomerTransactionsToInvoices = (
  transactions = [],
  redeemCodes = []
) => {
  if (!Array.isArray(transactions)) return [];

  const redeemCodeCounts = new Map();

  for (const code of Array.isArray(redeemCodes) ? redeemCodes : []) {
    if (!code?.transaction_id) continue;

    redeemCodeCounts.set(
      code.transaction_id,
      (redeemCodeCounts.get(code.transaction_id) || 0) + 1
    );
  }

  return transactions.map((transaction) => {
    const metadata = transaction?.metadata || {};
    const createdAt = transaction?.created_at;

    return {
      id: metadata.prettyInvoiceId || transaction?.transaction_id,
      transactionId: transaction?.transaction_id,
      amount: Number.parseFloat(transaction?.amount || 0),
      status: "paid",
      redeemCodeCount: redeemCodeCounts.get(transaction?.transaction_id) || 0,
      issueDate: createdAt
        ? new Date(createdAt).toLocaleDateString()
        : new Date().toLocaleDateString(),
      items: metadata.lineItems?.length || 0,
      paidDate: createdAt ? new Date(createdAt).toLocaleDateString() : null,
    };
  });
};
